// data/projects.js
const projects = [
  {
    title: {
      en: "Portfolio Website",
      ar: "موقع بورتفوليو",
    },
    description: {
      en: "A personal portfolio website built with React to showcase skills and projects, with email sending capability.",
      ar: "موقع بورتفوليو شخصي تم إنشاؤه باستخدام React لعرض المهارات والمشاريع، فضلاً عن إمكانية إرسال بريد إلكتروني.",
    },
    link: "",
  },
  {
    title: {
      en: "To-Do List App",
      ar: "تطبيق قائمة مهام",
    },
    description: {
      en: "A responsive to-do list app compatible with all screen sizes, following best coding practices and clean code structure.",
      ar: "موقع قائمة مهام متجاوب مع جميع الشاشات حيث تم استخدام فيه أفضل الممارسات الصحيحة وعزل الكود تماماً.",
    },
    link: "https://mhmdtaqi-code.github.io/TodoList-react/",
  },
  {
    title: {
      en: "Movies App",
      ar: "تطبيق أفلام",
    },
    description: {
      en: "A movie listing app that is responsive across all screen sizes, featuring a search functionality.",
      ar: "تطبيق عرض قائمة بالأفلام متجاوب مع جميع الشاشات مع خاصية البحث.",
    },
    link: "https://mhmdtaqi-code.github.io/movies-web/",
  },
  {
    title: {
      en: "Social Media Website",
      ar: "تطبيق موقع تواصل اجتماعي",
    },
    description: {
      en: "A responsive social media site that supports user registration, login, creating and commenting on posts, and viewing others' posts.",
      ar: "موقع تواصل اجتماعي متوافق مع جميع الشاشات، يدعم تسجيل كمستخدم جديد وتسجيل الدخول، فضلاً عن إنشاء ونشر وتعليق على المنشورات ورؤية التعليقات والمنشورات الأخرى.",
    },
    link: "https://mhmdtaqi-code.github.io/Social-Media/home.html",
  },
];

export default projects;
